import React, { useCallback, useEffect, useState } from "react";
import {
  ActivityIndicator,
  FlatList,
  Image,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { FontAwesome } from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useIsFocused } from "@react-navigation/native";
import { LinearGradient } from "expo-linear-gradient";
import { FormattedMessage } from "react-intl";
import api from "../../services/api";
import { toast } from "../../utils/toast";
import styles from "./styles";
import HeaderTabs from "../../components/HeaderTabs";
import GoBackButton from "../../components/GoBackButton";

const MyCards = ({ navigation }) => {
  const [cards, setCards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const isFocused = useIsFocused();

  useEffect(() => {
    getDataCards();
  }, [isFocused]);

  async function getDataCards() {
    setIsLoading(true);
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    api
      .get("/cards", { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        const fetchedCards = res.data.data.map((item) => ({
          name: item.name,
          number: item.card_number,
          validity: item.expiration_date,
          id: item.id,
        }));

        setCards(fetchedCards);
        setIsLoading(false);
      })
      .catch(() => {
        toast(
          intl.formatMessage({ id: "myCards.erroCarregaDados" }),
          "#DA1414"
        );
        setIsLoading(false);
      });
  }

  const renderCard = useCallback(
    ({ item }) => (
      <View style={styles.contentCard}>
        <TouchableOpacity
          style={styles.contentEdit}
          onPress={() => navigation.navigate("EditCard", { item })}
        >
          <FontAwesome name="edit" size={24} color="#000" />
        </TouchableOpacity>
        <Text style={styles.lbl}>
          <FormattedMessage id="newCard.placeholderNumCartao" />
        </Text>
        <Text style={styles.textDescription}>{item.number}</Text>
        <Text style={styles.lbl}>
          <FormattedMessage id="newCard.placeholderNomeCompleto" />
        </Text>
        <Text style={styles.textDescription}>{item.name}</Text>
        <Text style={styles.lbl}>
          <FormattedMessage id="newCard.placeholderValidade" />
        </Text>
        <Text style={styles.textDescription}>{item.validity}</Text>
        <Image
          source={require("../../../assets/masterCard.png")}
          style={styles.imgBank}
        />
      </View>
    ),
    [navigation]
  );

  return (
    <>
      <HeaderTabs title={<FormattedMessage id="myCards.headerMeusCartoes" />} />

      {isLoading ? (
        <ActivityIndicator
          color="#2797A2"
          size="large"
          style={{ marginTop: 10 }}
        />
      ) : cards.length === 0 ? (
        <Text style={styles.textNotFoundAccounts}>
          <FormattedMessage id="myCards.erroNenhumCartaoEncontrato" />
        </Text>
      ) : (
        <FlatList
          data={cards}
          renderItem={renderCard}
          keyExtractor={(item) => item.id.toString()}
          numColumns={2}
          columnWrapperStyle={{
            justifyContent: "space-evenly",
            width: "50%",
            alignSelf: "center",
            flexWrap: "wrap",
            flex: 1,
          }}
          contentContainerStyle={{ paddingBottom: 20 }}
        />
      )}

      <View style={styles.container}>
        <TouchableOpacity
          style={styles.btnAdd}
          onPress={() => navigation.navigate("NewCard")}
        >
          <Text style={styles.textBtn}>
            <FormattedMessage id="myCards.btnCadastraCartao" />
          </Text>
        </TouchableOpacity>

        <GoBackButton style={{ marginTop: 12, height: 48 }} />
      </View>
    </>
  );
};

export default MyCards;
